import React from "react";

import type { TextAreaProps as UITextAreaProps } from "../../UI/TextArea";
import { TextArea as UITextArea } from "../../UI/TextArea";
import { InputLabel } from "../../UI/InputLabel";

export interface TextAreaProps extends UITextAreaProps {
  errors?: Record<string, any>;
  minimumRows?: number;
}

export const TextArea: React.FC<TextAreaProps & any> = React.forwardRef((props, ref) => (
  <>
    {props.label && <InputLabel htmlFor={props.id}>{props.label}</InputLabel>}
    <UITextArea {...(props as any)} ref={ref} />
  </>
));
